/**
 * VK Recommendations - Complete Controller v5
 * Fixed variant switch + faster buttons
 */
(function() {
  'use strict';

  var isHydrated = false;
  var lineKeyCache = {};

  function toInt(val, fallback) {
    var n = parseInt(String(val), 10);
    return isFinite(n) ? n : fallback;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.json() : null; })
      .catch(function() { return null; });
  }

  function findLineForVariant(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (toInt(cart.items[i].variant_id, 0) === variantId) {
        return cart.items[i];
      }
    }
    return null;
  }

  function addToCart(variantId, qty) {
    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(qty || 1));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd,
      credentials: 'same-origin'
    });
  }

  function changeLineQty(lineKey, newQty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQty }),
      credentials: 'same-origin'
    });
  }

  function setActive(control, active) {
    if (!control) return;
    if (active) {
      control.classList.add('is-active');
    } else {
      control.classList.remove('is-active');
    }
  }

  function setQtyDisplay(form, qty) {
    var display = form.querySelector('[data-vk-reco-display]');
    var input = form.querySelector('[data-qty-input]');
    if (display) display.textContent = String(qty);
    if (input) input.value = String(qty);
  }

  function getCurrentQty(form) {
    var display = form.querySelector('[data-vk-reco-display]');
    return display ? toInt(display.textContent, 1) : 1;
  }

  function getVariantId(form) {
    var input = form.querySelector('[data-variant-id]');
    return input ? toInt(input.value, 0) : 0;
  }

  // ============================================
  // SERVES BUTTON (6/12) - Check cart FIRST
  // ============================================
  function handleServesClick(e) {
    var btn = e.target.closest('[data-serves-id]');
    if (!btn) return;
    if (!btn.closest('product-recommendations')) return;

    e.preventDefault();
    e.stopPropagation();

    var form = btn.closest('form');
    if (!form) return;

    var variantId = toInt(btn.getAttribute('data-serves-id'), 0);
    if (!variantId) return;

    // Update button states immediately
    var allBtns = form.querySelectorAll('[data-serves-id]');
    for (var i = 0; i < allBtns.length; i++) {
      allBtns[i].classList.remove('is-active');
      allBtns[i].setAttribute('aria-pressed', 'false');
    }
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');

    // Update hidden input
    var variantInput = form.querySelector('[data-variant-id]');
    if (variantInput) {
      variantInput.value = String(variantId);
    }

    var control = form.querySelector('[data-vk-reco-control]');

    // Check cart FIRST, then update UI (no flash of Add button)
    fetchCart().then(function(cart) {
      var line = findLineForVariant(cart, variantId);
      if (line && line.quantity > 0) {
        lineKeyCache[variantId] = line.key;
        setActive(control, true);
        setQtyDisplay(form, line.quantity);
      } else {
        setActive(control, false);
        setQtyDisplay(form, 1);
      }
    });
  }

  // ============================================
  // ADD BUTTON
  // ============================================
  function handleAddClick(e) {
    var btn = e.target.closest('[data-vk-reco-add]');
    if (!btn) return;
    if (!btn.closest('product-recommendations')) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;

    var form = btn.closest('form');
    if (!form) return;

    var variantId = getVariantId(form);
    if (!variantId) return;

    var control = form.querySelector('[data-vk-reco-control]');

    // OPTIMISTIC: Show stepper immediately
    setActive(control, true);
    setQtyDisplay(form, 1);

    addToCart(variantId, 1)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.key) {
          lineKeyCache[variantId] = data.key;
        }
      })
      .catch(function() {
        setActive(control, false);
      });
  }

  // ============================================
  // PLUS BUTTON - No blocking
  // ============================================
  function handlePlusClick(e) {
    var btn = e.target.closest('[data-vk-reco-plus]');
    if (!btn) return;
    if (!btn.closest('product-recommendations')) return;

    e.preventDefault();
    e.stopPropagation();

    var form = btn.closest('form');
    if (!form) return;

    var variantId = getVariantId(form);
    if (!variantId) return;

    var currentQty = getCurrentQty(form);
    var newQty = currentQty + 1;

    // OPTIMISTIC: Update immediately
    setQtyDisplay(form, newQty);

    addToCart(variantId, 1)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.key) {
          lineKeyCache[variantId] = data.key;
        }
      });
  }

  // ============================================
  // MINUS BUTTON - No blocking
  // ============================================
  function handleMinusClick(e) {
    var btn = e.target.closest('[data-vk-reco-minus]');
    if (!btn) return;
    if (!btn.closest('product-recommendations')) return;

    e.preventDefault();
    e.stopPropagation();

    var form = btn.closest('form');
    if (!form) return;

    var variantId = getVariantId(form);
    if (!variantId) return;

    var control = form.querySelector('[data-vk-reco-control]');
    var currentQty = getCurrentQty(form);
    var nextQty = Math.max(0, currentQty - 1);

    // OPTIMISTIC: Update immediately
    if (nextQty <= 0) {
      setActive(control, false);
      setQtyDisplay(form, 1);
    } else {
      setQtyDisplay(form, nextQty);
    }

    var lineKey = lineKeyCache[variantId];

    if (lineKey) {
      changeLineQty(lineKey, nextQty);
    } else {
      fetchCart().then(function(cart) {
        var line = findLineForVariant(cart, variantId);
        if (line && line.key) {
          lineKeyCache[variantId] = line.key;
          changeLineQty(line.key, nextQty);
        }
      });
    }
  }

  // ============================================
  // HYDRATE ON LOAD (only once)
  // ============================================
  function hydrateAllCards() {
    if (isHydrated) return;
    
    var forms = document.querySelectorAll('product-recommendations [data-reco-add-form]');
    if (!forms.length) return;

    isHydrated = true;

    fetchCart().then(function(cart) {
      forms.forEach(function(form) {
        var variantId = getVariantId(form);
        if (!variantId) return;

        var line = findLineForVariant(cart, variantId);
        var control = form.querySelector('[data-vk-reco-control]');

        if (line && line.quantity > 0) {
          lineKeyCache[variantId] = line.key;
          setActive(control, true);
          setQtyDisplay(form, line.quantity);
        } else {
          setActive(control, false);
          setQtyDisplay(form, 1);
        }
      });
    });
  }

  // ============================================
  // EVENT LISTENERS
  // ============================================
  document.addEventListener('click', handleServesClick, true);
  document.addEventListener('click', handleAddClick, true);
  document.addEventListener('click', handlePlusClick, true);
  document.addEventListener('click', handleMinusClick, true);

  function checkAndHydrate() {
    if (isHydrated) return;
    var hasRecoForm = document.querySelector('product-recommendations [data-reco-add-form]');
    if (hasRecoForm) {
      hydrateAllCards();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(checkAndHydrate, 500);
    });
  } else {
    setTimeout(checkAndHydrate, 500);
  }

  var observer = new MutationObserver(function() {
    if (!isHydrated) {
      checkAndHydrate();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();